module.exports = __webpack_public_path__ + "img/balearic-islands.89d5f4e1.svg";